import { Crown, History } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPE_LABELS = { corporate: "Corporate", rebel: "Rebel", blackout: "Blackout" };

const formatElapsed = (seconds) => {
  if (!Number.isFinite(seconds)) return "—";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return mins ? `${mins}M ${String(secs).padStart(2, "0")}S` : `${secs}S`;
};

export function BingoChampionHistory({ refreshKey = 0 }) {
  const [weeks, setWeeks] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API}/dolopals/bingo/champions`, { cache: "no-store" });
      if (!response.ok) throw new Error("Champion archive unavailable");
      const data = await response.json();
      setWeeks(Array.isArray(data.weeks) ? data.weeks : []);
    } catch {
      setWeeks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return (
    <section className="bingo-champion-history" data-testid="bingo-champion-history">
      <div className="bingo-champion-history-head">
        <span><History size={13} /> CHAMPION HISTORY</span>
        <h3>Hall of crowned weeks</h3>
      </div>
      {loading ? <p className="leaderboard-empty" data-testid="bingo-champion-history-loading">SCANNING CROWN ARCHIVE…</p> : null}
      {!loading && !weeks.length ? <p className="leaderboard-empty" data-testid="bingo-champion-history-empty">NO CROWNS ARCHIVED YET.</p> : null}
      <div className="bingo-champion-weeks">
        {weeks.slice(0, 4).map((week) => (
          <article className="bingo-champion-week" key={week.week} data-testid={`bingo-champion-week-${week.week}`}>
            <h4>{week.week}</h4>
            <div>
              {week.champions.map((champion) => (
                <p key={`${week.week}-${champion.victory_type}`} data-testid={`bingo-champion-${week.week}-${champion.victory_type}`}>
                  <Crown size={13} />
                  <span>{TYPE_LABELS[champion.victory_type] || champion.victory_type}</span>
                  <strong>{champion.name}</strong>
                  <em>{formatElapsed(champion.elapsed_seconds)}</em>
                </p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
